import { UtilService } from './../util/util.service';
import { Injectable } from '@angular/core';

declare let paymentV2AB;
declare let DCEmandateAB;
declare let follow_campaign;
declare let ketto_promise;
declare let frequencyTypAB;
declare let story_navigation;
// declare let downloadAppAB;
declare let tenureTypAB;
declare let stroy_donation_form_changes;
declare let trial_based_donationAB;
declare let dm_banner_AB;
declare let spinWheelAB;
declare let talk_to_us_AB;
declare let story_one_tap_AB;
declare let slabs_usa_AB;
declare let videopopup_AB;
declare let appdownload_exitintent_AB;
declare let intent_payu_AB;
declare let otd_to_sip_AB;
declare let dm_lives_AB;
declare let social_share_btns;
declare let min_donation_AB;
declare let banner_anniversary_AB;
declare let mostdonated_tag_AB;
declare let upi_onetap;
declare let life_slab_AB;
declare let dm_slab_experiment_AB;
declare let header_10_year_AB;
declare let top_supporter_AB;
declare let story_carousel_AB;
declare let razorpay_upi_sip_AB;
declare let story_popup_AB;
declare let homepage_banner_AB;
declare let tickr_mini_story_AB;
declare let ministory_iterations_p2_AB;
declare let sticky_share_AB;
declare let min_sip_typ_AB;
declare let dm_new_slab_AB;
declare let storyv3_fallback_p1_AB;
declare let quickDonate_fallback_p1_AB;
declare let exit_intent_AB;
declare let fifty_rupee_nudge_AB;
declare let other_amount_AB;
declare let why_ketto_AB;
declare let multicause_typ_non_inr_AB;
declare let sip_pitch_card_v4;
declare let quickDonate_fr_AB;
declare let story_promo_homeAB;
declare let phonepay_AB;
declare let bulk_donationAB;
declare let otd_to_sip_check_AB;
declare let slab_AB;
declare let ticker_otd_AB;
declare let tip_on_updateAB;
declare let multi_cause_dm_AB;
declare let sip_pitch_top_bottom_banner_AB;
declare let other_amount_otd_AB;
declare let typ_multi_cause_AB;
declare let dm_video_AB;
declare let min_amount_storyAB;

@Injectable({
  providedIn: 'root'
})
export class VwoService {

  constructor(
    private utilService: UtilService
  ) { }

  /** Get the variable of tickr AB Test */
  getTickrVariable() {
    if (typeof window !== 'undefined') {
      if (window.location.pathname.includes('/stories/') || this.utilService.isMobile()) {
        return true;
      }
    }
    return false;
  }

  paymentV2AB() {
    if (typeof paymentV2AB !== 'undefined') {
      return paymentV2AB;
    }
  }

  DCEmandateAB() {
    if (typeof DCEmandateAB !== 'undefined') {
      return DCEmandateAB;
    }
  }

  follow_campaignAB() {
    if (typeof follow_campaign !== 'undefined') {
      return follow_campaign;
    }
  }

  ketto_promiseAB() {
    if (typeof ketto_promise !== 'undefined') {
      return ketto_promise;
    }
  }

  frequencyTypAB() {
    if (typeof frequencyTypAB !== 'undefined') {
      return frequencyTypAB;
    }
  }

  story_navigationAB() {
    if (typeof story_navigation !== 'undefined') {
      return story_navigation;
    }
  }

  // downloadAppAB() {
  //   if (typeof downloadAppAB !== 'undefined') {
  //     return downloadAppAB;
  //   }
  // }

  tenureTypAB() {
    if (typeof tenureTypAB !== 'undefined') {
      return tenureTypAB;
    }
  }

  story_donation_form_changesAB() {
    if (typeof stroy_donation_form_changes !== 'undefined') {
      return stroy_donation_form_changes;
    }
  }

  trial_based_donationAB() {
    if (typeof trial_based_donationAB !== 'undefined') {
      return trial_based_donationAB;
    }
  }

  dm_banner_AB() {
    if (typeof dm_banner_AB !== 'undefined') {
      return dm_banner_AB;
    }
  }

  spinWheelAB() {
    if (typeof spinWheelAB !== 'undefined') {
      return spinWheelAB;
    }
  }

  talk_to_us_AB() {
    if (typeof talk_to_us_AB !== 'undefined') {
      return talk_to_us_AB;
    }
  }

  story_one_tap_AB() {
    if (typeof story_one_tap_AB !== 'undefined') {
      return story_one_tap_AB;
    }
  }

  slabs_usa_AB() {
    if (typeof slabs_usa_AB !== 'undefined') {
      return slabs_usa_AB;
    }
  }

  videopopup_AB() {
    if (typeof videopopup_AB !== 'undefined') {
      return videopopup_AB;
    }
  }

  appdownload_exitintent_AB() {
    if (typeof appdownload_exitintent_AB !== 'undefined') {
      return appdownload_exitintent_AB;
    }
  }

  intent_payu_AB() {
    if (typeof intent_payu_AB !== 'undefined') {
      return intent_payu_AB;
    }
  }

  otd_to_sip_AB() {
    if (typeof otd_to_sip_AB !== 'undefined') {
      return otd_to_sip_AB;
    }
  }

  dm_lives_AB() {
    if (typeof dm_lives_AB !== 'undefined') {
      return dm_lives_AB;
    }
  }

  social_share_btns_AB() {
    if (typeof social_share_btns !== 'undefined') {
      return social_share_btns;
    }
    return true;
  }

  min_donation_AB() {
    if (typeof min_donation_AB !== 'undefined') {
      return min_donation_AB;
    }
  }

  banner_anniversary_AB() {
    if (typeof banner_anniversary_AB !== 'undefined') {
      return banner_anniversary_AB;
    }
  }

  mostdonated_tag_AB() {
    if (typeof mostdonated_tag_AB !== 'undefined') {
      return mostdonated_tag_AB;
    }
  }

  upi_onetap_AB() {
    if (typeof upi_onetap !== 'undefined') {
      return upi_onetap;
    }
  }

  top_supporter_AB() {
    if (typeof top_supporter_AB !== 'undefined') {
      return top_supporter_AB;
    }
  }

  story_carousel_AB() {
    if (typeof story_carousel_AB !== 'undefined') {
      return story_carousel_AB;
    }
  }

  dm_slab_experiment_AB() {
    if (typeof dm_slab_experiment_AB !== 'undefined') {
      return dm_slab_experiment_AB;
    }
  }

  header_10_year_AB() {
    if (typeof header_10_year_AB !== 'undefined') {
      return header_10_year_AB;
    }
  }

  life_slab_AB() {
    if (typeof life_slab_AB !== 'undefined') {
      return life_slab_AB;
    }
  }

  razorpay_upi_sip_AB() {
    if (typeof razorpay_upi_sip_AB !== 'undefined') {
      return razorpay_upi_sip_AB;
    }
  }

  story_popup_AB() {
    if (typeof story_popup_AB !== 'undefined') {
      return story_popup_AB;
    }
  }

  homepage_banner_AB() {
    if (typeof homepage_banner_AB !== 'undefined') {
      return homepage_banner_AB;
    }
  }

  tickr_mini_story_AB() {
    if (typeof tickr_mini_story_AB !== 'undefined') {
      return tickr_mini_story_AB;
    }
  }

  ministory_iterations_p2_AB() {
    if (typeof ministory_iterations_p2_AB !== 'undefined') {
      return ministory_iterations_p2_AB;
    }
  }

  sticky_share_AB() {
    if (typeof sticky_share_AB !== 'undefined') {
      return sticky_share_AB;
    }
  }

  min_sip_typ_AB() {
    if (typeof min_sip_typ_AB !== 'undefined') {
      return min_sip_typ_AB;
    }
  }

  dm_new_slab_AB() {
    if (typeof dm_new_slab_AB !== 'undefined') {
      return dm_new_slab_AB;
    }
  }

  storyv3_fallback_p1_AB() {
    if (typeof storyv3_fallback_p1_AB !== 'undefined') {
      return storyv3_fallback_p1_AB;
    }
  }

  quickDonate_fallback_p1_AB() {
    if (typeof quickDonate_fallback_p1_AB !== 'undefined') {
      return quickDonate_fallback_p1_AB;
    }
    // return 'v2';
  }

  quickDonate_fr_AB() {
    if (typeof quickDonate_fr_AB !== 'undefined') {
      return quickDonate_fr_AB;
    }
  }

  exit_intent_AB() {
    if (typeof exit_intent_AB !== 'undefined') {
      return exit_intent_AB;
    }
  }

  fifty_rupee_nudge_AB() {
    if (typeof fifty_rupee_nudge_AB !== 'undefined') {
      return fifty_rupee_nudge_AB;
    }
  }

  other_amount_AB() {
    if (typeof other_amount_AB !== 'undefined') {
      return other_amount_AB;
    }
  }

  why_ketto_AB() {
    if (typeof why_ketto_AB !== 'undefined') {
      return why_ketto_AB;
    }
  }

  multicause_typ_non_inr_AB() {
    if (typeof multicause_typ_non_inr_AB !== 'undefined') {
      return multicause_typ_non_inr_AB;
    }
    // return true;
  }

  sip_pitch_card_v4() {
    if (typeof sip_pitch_card_v4 !== 'undefined') {
      return sip_pitch_card_v4;
    }
  }

  story_promo_homeAB() {
    if (typeof story_promo_homeAB !== 'undefined') {
      return story_promo_homeAB;
    }
  }

  phonepay_AB() {
    if (typeof phonepay_AB !== 'undefined') {
      return phonepay_AB;
    } 
  }

  bulk_donationAB() {
    if (typeof bulk_donationAB !== 'undefined') {
      return bulk_donationAB;
    }
    // return true;
  }

  otd_to_sip_check_AB() {
    if (typeof otd_to_sip_check_AB !== 'undefined') {
      return otd_to_sip_check_AB;
    }
  }

  slab_AB() {
    if (typeof slab_AB !== 'undefined') {
      return slab_AB;
    }
    // return 'non_inr_ab'
  }

  ticker_otd_AB() {
    if (typeof ticker_otd_AB !== 'undefined') {
      return ticker_otd_AB;
    }
  }

  tip_on_updateAB() {
    if (typeof tip_on_updateAB !== 'undefined') {
      return tip_on_updateAB;
    }
    // return true;
  }

  multi_cause_dm_AB() {
    if (typeof multi_cause_dm_AB !== 'undefined') {
      return multi_cause_dm_AB;
    }
    // return true;
  }

  sip_pitch_top_bottom_banner_AB() {
    if (typeof sip_pitch_top_bottom_banner_AB !== 'undefined') {
      return sip_pitch_top_bottom_banner_AB;
    }
    // return true;
  }

  other_amount_otd_AB() {
    if (typeof other_amount_otd_AB !== 'undefined') {
      return other_amount_otd_AB;
    }
  }

  typ_multi_cause_AB() {
    if (typeof typ_multi_cause_AB !== 'undefined') {
      return typ_multi_cause_AB;
    }
  }

  dm_video_AB() {
    if (typeof dm_video_AB !== 'undefined') {
      return dm_video_AB;
    }
    // return true;
  }

  min_amount_storyAB() {
    if (typeof min_amount_storyAB !== 'undefined') {
      return min_amount_storyAB;
    }
    // return true;
  }

}
